var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"c-loading-animation"},[_c('object',{staticClass:"c-loading-animation__visual",attrs:{"data":"assets/images/loading-animation/animation.svg","type":"image/svg+xml"}})])
}]

export { render, staticRenderFns }